import React, {forwardRef} from 'react';
import './Footer.css'

interface FooterProps {
  // Define props here
}

const Footer = forwardRef<HTMLDivElement, {}>((props, ref) => {
  return (
    <footer className="site-footer">
      <div className="footer-content">
        <p className="footer-title">© {new Date().getFullYear()} Overcoming Temptation</p>
        <div className="footer-links">
          <a href="/introduction">Read</a>
          <a href="/download">Download</a>
          <a href="/about">About the Author</a>
          <a href="/totd">Thought of the Day</a>
        </div>
      </div>
    </footer>
  );
});

export default Footer;
